import React, { useEffect, useState } from 'react';
import { TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Button, TextField, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getRolesAndResponsibilities, postRolesAndResponsibilities } from '../../../../../actions/tigercat-burns/tigercat-base-actions';

const RolesAndResponsibilities = ({ projectId }) => {
    const dispatch = useDispatch();
    const rolesAndResponsibilities = useSelector(state => state.tigercatBurnsBaseReducer.rolesAndResponsibilities.data);

    // Local state for editing/adding rows
    const [rows, setRows] = useState([]);

    useEffect(() => {
        dispatch(getRolesAndResponsibilities(projectId));
    }, [dispatch, projectId]);

    useEffect(() => {
        if (rolesAndResponsibilities) {
            setRows(rolesAndResponsibilities);
        }
    }, [rolesAndResponsibilities]);

    const handleAddRow = () => {
        setRows([...rows, { name: '', role: '', responsibility: '' }]);
    };

    const handleChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setRows(updatedRows);
    };

    const handleSubmitData = () => {
        // Optionally filter out empty rows before submitting
        const filteredRows = rows.filter(
            row => row.name || row.role || row.responsibility
        );
        dispatch(postRolesAndResponsibilities(projectId, filteredRows));
    };

    return (
        <>
            <h2>Roles and Responsibilities</h2>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="roles and responsibilities table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Role</TableCell>
                            <TableCell>Responsibility</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((data, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <TextField
                                        value={data?.name}
                                        onChange={(e) => handleChange(index, 'name', e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        value={data?.role}
                                        onChange={(e) => handleChange(index, 'role', e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        value={data?.responsibility}
                                        onChange={(e) => handleChange(index, 'responsibility', e.target.value)}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ display: 'flex', mb: 10 }}>
                <Button variant="contained" color="primary" onClick={handleAddRow} sx={{ mt: 2 }}>
                    Add Entry
                </Button>
                <Button variant='contained' sx={{ height: 'auto', mt: 2, ml: 3 }} onClick={handleSubmitData}>
                    Submit Data
                </Button>
            </Box>

        </>
    );
};
export default RolesAndResponsibilities;